import createIcon from '../../createIcon';

/**
 * @component @name NoMeetingRoom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNTY1NCA0LjQzNDQ1VjguMzE0NDVMMTQuNTY1NCAxMC4zMTQ1VjUuNDM0NDVIMTcuNTY1NFYxMy4zMTQ1TDE5LjU2NTQgMTUuMzE0NVYzLjQzNDQ1SDE0LjU2NTRWMi40MzQ0NUg2LjY4NTQzTDguNjg1NDMgNC40MzQ0NUgxMi41NjU0Wk0yLjk3NTQzIDEuNTY0NDVMMS41NjU0MyAyLjk3NDQ1TDUuNTY1NDMgNi45NzQ0NVYxOC40MzQ1SDMuNTY1NDNWMjAuNDM0NUgxNC41NjU0VjE1Ljk3NDVMMjEuMDI1NCAyMi40MzQ1TDIyLjQzNTQgMjEuMDI0NUwyLjk3NTQzIDEuNTY0NDVaTTEyLjU2NTQgMTguNDM0NUg3LjU2NTQzVjguOTc0NDVMMTIuNTY1NCAxMy45NzQ1VjE4LjQzNDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoMeetingRoom = createIcon('NoMeetingRoom', [
  [
    'path',
    {
      d: 'M12.5654 4.43445V8.31445L14.5654 10.3145V5.43445H17.5654V13.3145L19.5654 15.3145V3.43445H14.5654V2.43445H6.68543L8.68543 4.43445H12.5654ZM2.97543 1.56445L1.56543 2.97445L5.56543 6.97445V18.4345H3.56543V20.4345H14.5654V15.9745L21.0254 22.4345L22.4354 21.0245L2.97543 1.56445ZM12.5654 18.4345H7.56543V8.97445L12.5654 13.9745V18.4345Z',
      key: '1bw08x',
    },
  ],
]);

export default NoMeetingRoom;
